// Copyright (c) Docugami, Inc. All rights reserved.**/
import { useMemo } from "react";

export type StringPropertyKeys<Item> = Extract<keyof Item, string>

export function useCollectionKeyFilter<CollectionItem>(filterText: string, collection: CollectionItem[], properties: StringPropertyKeys<CollectionItem>[]) {
    return useMemo(() => {
        const lowercaseFilterText = filterText.toLocaleLowerCase();

        const isPropertyValueOfTypeString = (propertyValue: any): propertyValue is string => {
            return typeof propertyValue === 'string';
        }

        return collection.filter((item) => {
            for (const itemProp in item) {
                const itemPropValue = item[itemProp];
                if (properties.includes(itemProp) &&
                    !!item[itemProp] &&
                    isPropertyValueOfTypeString(itemPropValue) &&
                    itemPropValue.toLocaleLowerCase().includes(lowercaseFilterText)) {
                    return true;
                }
            }
            return false;
        });
    }, [collection, filterText, properties])
}

export function filterByCollectionKey<CollectionItem>(filterText: string, collection: CollectionItem[], properties: StringPropertyKeys<CollectionItem>[]) {
    const lowercaseFilterText = filterText.toLocaleLowerCase();

    const isPropertyValueOfTypeString = (propertyValue: any): propertyValue is string => {
        return typeof propertyValue === 'string';
    }

    return collection.filter((item) => {
        for (const itemProp in item) {
            const itemPropValue = item[itemProp];
            if (properties.includes(itemProp) &&
                !!item[itemProp] &&
                isPropertyValueOfTypeString(itemPropValue) &&
                itemPropValue.toLocaleLowerCase().includes(lowercaseFilterText)) {
                return true;
            }
        }
        return false;
    });
}